import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { removeCookie } from "./cookie";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const removeAuthCookies = () => {
  removeCookie("accessToken");
  // TODO: remove refresh token in the cookie
  // removeCookie("refreshToken");
};
